<template>
	<div class="inf_wrap">
		<p class="back_box" @click="back()">
			<img src="../../../static/images/back.png" alt=""> 返回上一页
		</p>
		<div class="box_req">
			<h2>回复方案及报价详情</h2>
      <div style="margin-bottom: 10px;">案件编号：{{detailList.obj.obj.caseNo}}</div>
       <ParheaderVue :detailList='detailList' />
       <Parinf :detailList='detailList' />
       

			<div class="req_box" style="margin-top:20px">
				<b>救援方案</b>
				<div class="acc_box">
					<p v-if="acc_list.length == 0"><img class="fj_box" src="../../../static/images/fj.png" alt=""> <span>附件(0)</span></p>
					<attaList :attaArr='acc_list'></attaList>
				</div>

			</div>
			<h4>报价</h4>
			<div class="offer_box">
				<div>
					<span>
						<span class="testWidth">救援机构总报价：</span>
                  <b>{{obj.totalFee||0}} {{obj.currency}}</b>
            </span>
            <span>
              救援费用：<b>{{obj.rescueFee||0}} {{obj.currency}}</b>
            </span>
            <span v-if="typeId != 800">
              医疗费用：<b>{{obj.medicFee||0}} {{obj.currency}}</b>
            </span>
            <span  v-if="typeId != 800">
              案件服务费用：<b>{{obj.caseFee||0}} {{obj.currency}}</b>
            </span>
				</div>
			</div>

			<div class="offer_box" v-if="!flag">
				<p>
					<span>
						<span class="testWidth">保险公司收到的价格：</span>
                  <b>{{totalFee||0}} {{currency}}</b>
                </span>
					<span>
                  救援费用：<b>{{rescueFee||0}} {{currency}}</b>
                </span>
					<span  v-if="typeId != 800">
                  医疗费用：<b>{{medicFee||0}} {{currency}}</b>
                </span>
				</p>
			</div>
				<div class="baojia" v-if="flag">
					<div class="checkedLi">
						<p>总结报价</p>
						<div class="seleceBox" @mouseleave="seleceShow=false">
							<p @click="seleceShow=!seleceShow">{{moneyCheck}}</p>
							<ul v-show="seleceShow">
								<li v-for="item in moneyList" @click="selectFun(item)">{{item.name}} {{item.label}}</li>
							</ul>
						</div>
					</div>
					<div class="write">
						<ul>
							<li>
								<p>救援费用:</p>
								<input type="text" v-model="rescueFee" @input="upnum(rescueFee)" />
								<span>{{moneySymbol}}</span>
							</li>
							<li v-if="typeId != 800">
								<p>医疗费用:</p>
								<input type="text" v-model="medicFee" @input="upnum(medicFee)" />
								<span>{{moneySymbol}}</span>
							</li>
						</ul>
					</div>
					<div class="allMoney">
						整体报价 :<span>{{rescueFee +  medicFee}} {{moneySymbol}}</span>
					</div>
				</div>

			<div class="rescue_box" v-for="(item,ind) in checkList" :key="ind">
				<p>{{item.name}}</p>
				<fuwuqingdan :attaArr=item.list></fuwuqingdan>
			</div>
        <div style="color:red;margin-bottom:10px;text-align: center;" v-if="typeId == 800">家财服务商费用＞230元，联系平安授权！（仅限制开锁，马桶疏通）</div>
			<div class="upbtn_box">
				<span v-if="flag" @click="reject(obj.solutionNo)">不选择此家报价</span>
				<el-button type="primary" @click="back()">关闭报价详情</el-button>
      
				<el-button type="primary" v-if="flag && isStatus != 2" @click="adopt(obj.solutionNo)">
          同意报价，{{ifType == 2 ? '转交监管机构授权':'启动救援'}}
        </el-button>
        <el-tooltip content="案件已被保险公司认定无责，请关闭" placement="top">
          <span></span>
          <span v-if="isStatus == 2" @click="closeCase">关闭案件</span>
        </el-tooltip>
			</div>
		</div>
	</div>
</template>

<script>
  import ParheaderVue from "../../views/commonPage/details/parheader.vue";
  import Parinf from "../../views/commonPage/details/Parinf.vue";
	import qs from "qs";
	import "isomorphic-fetch";
	import constants from '@/util/constants.js';
	import Promise from 'promise-polyfill';
	import err from "@/util/error2msg.js";
	import { Message } from "element-ui";
	import attaList from "@/components/attachment/index1";
	import fuwuqingdan from "@/components/attachment/qingdan";
  import { getCasedetail,closeOrdinaryCase } from '@/views/axios/api.js'
	if(!window.Promise) {
		window.Promise = Promise;
	}
  
	export default {
		data() {
			return {
          detailList:{
          obj:{
            obj:{
              incidentType:''
            }
          }
        },
				exp: "",
				token:JSON.parse(window.localStorage.getItem("data")).data,
				caseid: this.$route.query.caseid,
				bidId: this.$route.query.bidId,
				acc_list: [],
				formInline: {
					user: "",
					region: ""
				},
				checkList: [],
				parentObj: [],
				flag: false,
				obj: {
					totalFee: 0,
					rescueFee: 0,
					medicFee: 0,
					caseFee: 0
				},
				totalFee: 0,
				rescueFee: 0,
				medicFee: 0,
				caseFee: 0,
				currency:'',
				typeId: this.$route.query.typeId,
				moneyList: [
					{
						name: '人民币',
						label: 'RMB'
					},
					{
						name: '美元',
						label: 'USD'
					},
					{
						name: '欧元',
						label: 'EUR'
					},
					{
						name: '日元',
						label: 'JPY'
					},
					{
						name: '新台币',
						label: 'TWD'
					}
				],
				bjValue: '',
				seleceShow:false,//下拉框
				moneyCheck:'',
				moneySymbol:'',
        ifType:'',
        isStatus:''
			};
		},
    
		components: {
			attaList,
       ParheaderVue,
      Parinf,
			fuwuqingdan
		},
		methods: {
        getCasedetail(){//获取详情
        var data = {
        	token: this.token,
        	caseId: this.$route.query.caseid
        };
        getCasedetail1(data)
        .then(res => {
           console.log(res)
          this.detailList=this.detailLists[this.activeIndex];

          
        })
      },
			error2msg(errcode) {
				var errmsg = err;
				var msg = errmsg.tomsg(errcode);
				Message.error(msg);
			},
			selectFun(item){
				this.moneyCheck=item.name + " " + item.label;
				this.seleceShow=false;
				this.moneySymbol=item.label;
			},
			upnum(val) {
				if(isNaN(val)) {
					Message.error("请输入数字，而非其他");
				} else {
					if(!this.caseFee) {
						this.caseFee = 0;
					}
					if(!this.medicFee) {
						this.medicFee = 0;
					}
					if(!this.rescueFee) {
						this.rescueFee = 0;
					}
					this.medicFee = this.medicFee * 1;
					this.caseFee = this.caseFee * 1;
					this.rescueFee = this.rescueFee * 1;
					this.totalFee = this.medicFee + this.caseFee + this.rescueFee;
				}
			},
			reject(solutionNo) {
				this.axios
					.post(
						constants.domain + "rescue/bidding/update_bidding_state",
						qs.stringify({
							token: this.token,
							solutionNo,
							status: 2
						})
					)
					.then(res => {
						if(res.data.code != 0) {
							that.error2msg(res.data.code);
						} else {
							Message({
								message: "关闭成功",
								type: "success"
							});
							this.$router.push({
								name: "ComOffer",
								params: {
									time: new Date()
								},
								query: {
									typeId: this.typeId
								}
							});
						}
					});
			},
			adopt(solutionNo) {

        	this.axios
					.post(
						constants.domain + "rescue/bidding/update_bidding_state",
						qs.stringify({
							token: this.token,
							solutionNo,
							status: 1,
							totalFee: this.medicFee + this.rescueFee,
							medicFee: this.medicFee,
							caseFee: this.caseFee,
							rescueFee: this.rescueFee,
							currency:this.moneySymbol
						})
					)
					.then(res => {
						if(res.data.code != 0) {
              if(res.data.code == 101013) {
                this.$message.error('等待保险公司确认')
              }else if(res.data.code == 101014){
                this.$message.error('保险公司已确认无责')
              }
						} else {
							Message({
								message: "授权成功",
								type: "success"
							});
              if(this.typeId != 800) {
                this.$router.push({
								name: "ComOffer",
								params: {
									time: new Date()
								},
								query: {
									typeId: this.typeId
								}
							});
              }else {
                 this.$router.push({
								name: "Homestart",
								params: {
									time: new Date()
								},
								query: {
									typeId: this.typeId
								}
							});
              }
							
						}
					});
          
			
			},
			back() {
				this.$router.go(-1)
			},
			toalter() {
				this.$router.push("/regulator/caseindex/alter?typeId=" + this.typeId);
			},
      closeCase(){
        var data={
          token:this.token,
          caseId:this.caseid
        }
        closeOrdinaryCase(data)
        .then(res => {
          console.log(res);
          if(res.data.code == 0){
            this.$message.success('案件已关闭')
            this.$router.go(-1)
          }
        })
        .catch(err => {
          console.log(err);
        })
      }
		},
		mounted() {
      // this.getCasedetail()
      getCasedetail({
        token:this.token,
        caseId:this.$route.query.caseid
      })
      .then(res => {
        console.log(res)
        this.detailList = res.data
        this.ifType=res.data.obj.obj.contractType //1 大包 2 小包 3纯服务
        this.isStatus=res.data.obj.obj.insuranceLiabilityStatus //3有责，2无责
      })
      .catch(err => {
        console.log(err);
      })

			let that = this;
			let n = 0;
			fetch(
					constants.domain + "rescue/bidding/view_solution", {
						method: "POST",
						body: `token=${this.token}&biddingId=${this.bidId}`,
						mode: "cors",
						headers: {
							"Content-Type": "application/x-www-form-urlencoded"
						}
					}
				)
				.then(function(res) {
					return res.json();
				})
				.then(function(data) {
					that.obj = data.obj;
					that.moneySymbol = that.obj.currency;
          that.moneyList.forEach(item => {
            if(item.label == that.moneySymbol){
              that.selectFun(item)
            }
          })
					that.flag = data.obj.state == 1;
					data.obj2.map(v => {
						if(v.dict.parentId == "0") {
							var obj = {};
							obj.id = v.dict.parentId;
							obj.childId = v.dict.id;
							obj.name = v.dict.name;
							obj.list = [];
							that.checkList.push(obj);
						} else {
							that.checkList.map(o => {
								if(v.dict.parentId == o.childId) {
									o.list.push(v);
								}
							});
						}
					});

					if(that.flag) {
						that.totalFee = that.obj.totalFee;
						that.rescueFee = that.obj.rescueFee;
						that.medicFee = that.obj.medicFee;
						that.caseFee = that.obj.caseFee;
						that.currency = that.obj.currency;
					} else {
						that.axios
							.post(
								constants.domain + "rescue/bidding/view_case_solution",
								qs.stringify({
									token: that.token,
									caseId: that.caseid,
									state: 4
								})
							)
							.then(res => {
								var o = res.data.obj;
								that.totalFee = o.totalFee;
								that.rescueFee = o.rescueFee;
								that.medicFee = o.medicFee;
								that.caseFee = o.caseFee;
								that.currency = o.currency;
							});
					}
					//获取救援方案
					fetch(constants.domain + "rescue/case/upload_cnts", {
							method: "POST",
							body: `token=${that.token}&objId=${data.obj.id}&caseId=${that.$route.query.caseid}&objType=2`,
							mode: "cors",
							headers: {
								"Content-Type": "application/x-www-form-urlencoded"
							}
						})
						.then(function(res) {
							return res.json();
						})
						.then(function(data) {
							data.obj.map(v => {
								if(constants.isPic(v.url)) {
									v.icon = v.url;
								} else {
									v.icon = v.icon;
								}
								that.acc_list.push(v);
							});
						});
				});
		}
	};
</script>

<style scoped>
	@import url(../../css/lookinf.css);
	.acc_box p * {
		vertical-align: middle;
		color: #333;
	}
	.acc_box{margin-left: 40px;}
	.offer_box{padding-left: 40px;}
	.testWidth {display: inline-block;width: 150px;}

	.baojia {
		margin-left: 43px;
		margin-top: 10px;
	}

	.checkedLi {
		height: 42px;
	}

	.checkedLi p {
		float: left;
		line-height: 30px;
		font-size: 14px;
	}

	.checkedLi .seleceBox {
		float: left;
		margin-left: 10px;
	}

	.baojia .write {
		margin-left: 45px;
		overflow: hidden;
	}

	.baojia .write li {
		overflow: hidden;
		margin-top: 10px;
		float: left;
		margin-right: 50px;
		position: relative;
	}

	.baojia .write li p {
		float: left;
		line-height: 30px;
	}

	.baojia .write li input {
		float: left;
		margin-left: 10px;
		border: 1px solid #eee;
		height: 30px;
		line-height: 30px;
		color: #a0a0a0;
		border-radius: 3px;
		padding: 0 10px;
		outline: none;
		width: 150px;
	}

	.baojia .write li span {
		color: #666;
		position: absolute;
		top: 7px;
		right: 10px;
	}

	.baojia .allMoney {
		margin-left: 45px;
		margin-top: 20px;
		margin-bottom: 20px;
	}

	.baojia .allMoney span {
		color: #ff7200;
	}
	.seleceBox{position: relative;padding-bottom: 10px;}
	.seleceBox ul{position: absolute;top: 39px;left: 0;border: 1px solid #d9ddde;width: 150px;z-index: 2;background-color: white;border-radius: 3px;}
	.seleceBox p{width: 140px;height: 30px;line-height: 30px;border: 1px solid #d9ddde;padding-left: 10px;border-radius: 5px;font-size: 14px;color: #999;background: url('./../../assets/img/downErr.png') no-repeat 125px center;cursor: pointer;}
	.seleceBox ul li{line-height: 30px;padding-left: 10px;font-size: 14px;color: #999;}
	.seleceBox ul li:hover{background-color:#f6f6f6;cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/components/cmd_center/Lookinf.vue